// 动态设置viewport的vh值
!(function (n, e) {

  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  var ua = window.navigator.userAgent.toLowerCase();
  var isWX = ua.match(/MicroMessenger/i) == "micromessenger"
  var flag;
  var myFunction;
  setViewHeight()//ios和部分安卓浏览器会把工具栏或者导航栏的高度计算在内，所以需要减去这部分高度
  function setViewHeight() {
    //e.innerHeight ios键盘弹起后，会把页面向上顶，导致e.innerHeight变小
    //n.documentElement.clientHeight 不会变化
    var windowVH = e.innerHeight / 100
    n.documentElement.style.setProperty('--vh', windowVH + 'px')
  }

  if (isWX && isIOS) {//解决ios微信内页面高度变化,底部导航栏
    // 监听页面高度变化
    window.addEventListener('resize', () => {
      setViewHeight()
    })
  }
  if (isSafari) {
    document.body.addEventListener('focusin', () => { //软键盘弹起事件
      flag = true;
      clearTimeout(myFunction);
    })
    document.body.addEventListener('focusout', () => { //软键盘关闭事件
      flag = false;
      if (!flag) {
        myFunction = setTimeout(function () {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" })//重点 =======当键盘收起的时候让页面回到原始位置(这里的top可以根据你们个人的需求改变，并不一定要回到页面顶部)
          //等页面回到原始位置后，再设置vh值，此时能获取到正确的e.innerHeight
          setViewHeight()
        }, 200);
      } else {
        return
      }
    })
  } else {
    return
  }
})(document, window)